export const tryParse = (str?: string) => {
  try {
    return typeof str === 'object' ? str : JSON.parse(str || '');
  } catch (e) {
    return false;
  }
};

export const isJson = (str?: string) =>
  typeof str === 'object' || str === 'false' || !!tryParse(str);

export const tryStringify = (obj: any) => {
  try {
    return typeof obj === 'object' ? JSON.stringify(obj) : obj;
  } catch (e) {
    return obj;
  }
};

export const parseAlias = (url: string) =>
  url?.split('.')?.[0].split('//')?.[1]?.replace('cms-', '');
